export default "__VITE_ASSET__rhzD$PRm__"